import React from "react";
import { useFetch } from "@/hooks/useApi";
import { PageHeader, Loader } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { gbp } from "@/lib/format";
import * as Icons from "lucide-react";

const BudgetCard = ({ label, budget, actual, testId }) => {
  const pct = budget ? Math.min((actual / budget) * 100, 100) : 0;
  const over = actual > budget;
  return (
    <Card className="p-6" data-testid={testId}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display font-semibold">{label}</h3>
        {over ? <Icons.AlertTriangle className="h-5 w-5 text-rose-400" /> : <Icons.CheckCircle2 className="h-5 w-5 text-emerald-400" />}
      </div>
      <div className="flex items-end justify-between mb-2">
        <span className={`font-mono text-2xl font-bold ${over ? "text-rose-400" : "text-foreground"}`}>{gbp(actual)}</span>
        <span className="text-sm text-muted-foreground">of {gbp(budget)}</span>
      </div>
      <Progress value={pct} className={over ? "[&>div]:bg-rose-500" : "[&>div]:bg-emerald-500"} />
      <p className={`text-xs mt-2 ${over ? "text-rose-400" : "text-muted-foreground"}`}>
        {over ? `${gbp(actual - budget)} over budget` : `${gbp(budget - actual)} remaining`}
      </p>
    </Card>
  );
};

export default function FuelBudget() {
  const { data, loading } = useFetch("/fuel/budget");
  if (loading || !data) return <Loader />;
  return (
    <div className="fp-fade-in">
      <PageHeader title="Fuel Budget" subtitle="Actual spend vs planned budget across periods" testId="fuel-budget-page" />
      <div className="grid md:grid-cols-3 gap-5">
        <BudgetCard label="Daily" budget={data.daily.budget} actual={data.daily.actual} testId="budget-daily" />
        <BudgetCard label="Weekly" budget={data.weekly.budget} actual={data.weekly.actual} testId="budget-weekly" />
        <BudgetCard label="Monthly" budget={data.monthly.budget} actual={data.monthly.actual} testId="budget-monthly" />
      </div>
      <p className="text-sm text-muted-foreground mt-4">Adjust budgets in <span className="text-primary">Settings</span>.</p>
    </div>
  );
}
